import { useTranslation } from 'react-i18next';
import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//调拨管理
export default () => {
    
const { t } = useTranslation();
return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}